<!--
Container for displaying the content returned from the support and wellbeing content API based on user selection
@author dgm11b
-->

<template>
    <template v-for="(singleContent, index) in content">
        <div id="swContent" :class="['container sw-content', os]" @click="handleClick">
            <div v-html="content[index]"
            :class="[
                'container sw-content',
                index===0 ? 'p-3 pt-0' : 'p-4',
                index % 2 == 0 ? 'white-container' : 'blue-container'
            ]">
            </div>
        </div>
    </template>
</template>

<script setup>

import {defineProps} from 'vue';
import {useRouter} from 'vue-router';
import {useDeviceType} from '@/composables/DeviceCommon.js'

const router = useRouter()

const props = defineProps({
    content: {
        type: Array
    }
})

const os = useDeviceType();

//Any links clicked, check if internal app link and route if so
function handleClick(evt) {
    if(evt.target.dataset.appLink) {
        evt.preventDefault();
        router.push(evt.target.dataset.appLink)
    }
}

</script>

<style>

/*Because using v-html to display the content the html inserted cannot use the scoped css
* So using and ID #swContent on container to fake scope it to this component
* Want to avoid changing any global css at this stage*/

#swContent {
    padding:0px;
}

/* The global one has center alignment
Use this until changed */
#swContent h2 {
    text-align:left;
    font-size:20px;
}

#swContent .white-container h2 {
    color: #003865;
}


#swContent .blue-container p {
    color: #fff;
}

#swContent .phone-btn {
    display:inline-block;
    border-radius: 10px;
    background: #bfcdd8;
    color: #003865;
    font-size: 20px;
    padding: 9px 16px;
}

#swContent .blue-container {
    background-color: #003865;
    color:#fff;
}

#swContent .blue-container .phone-btn {
    background: #fff;
}

#swContent .btn {
    font-size:20px;
    background-color:#003865;
    border: solid 1px #003865;
    padding: 9px 16px;
    color:#fff;
    margin:4px 0px;
    line-height:normal;
    transition: background-color 0.4s, color 0.4s, border-color 0.4s;
}

#swContent .btn:hover {
    background-color:#fff;
    border: solid 1px #003865;
    color:#003865;
}

#swContent .btn:focus-visible {
    outline: 3px solid #000;
}


#swContent .btn:active {
    background-color: #003865;
    color: #fff;
}

#swContent .blue-container  .btn {
    background-color:#fff;
    border: solid 1px #fff;
    color:#003865;
}

#swContent .blue-container  .btn:hover {
    background-color:#003865;
    border: solid 1px #fff;
    color:#fff;
}

#swContent .blue-container .btn:focus-visible {
    outline: 3px solid #fff;
}

#swContent .blue-container .btn:active {
    background-color: #fff;
    color: #003865;
}

#appStoreLogos {
    overflow:auto;
    max-width: 365px;
}

#appStoreLogos a {
    display: inline-block;
    width: 50%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 65px;
    float: left;
}

a#playStore {
    background-image: url('@/assets/google-play-badge.png')
}

a#appStore {
    background-image: url('@/assets/apple-app-store-badge.svg');
    max-height: 45px;
    margin-top: 10px;
}

/*Hide store links on specific devices*/
.iOS a#playStore,
.Macintosh a#playStore {
    display:none;
}

.Android a#appStore {
    display:none;
}

/* Google Play image has spacing built in so when hidden, add padding to App Store image */
.iOS a#appStore,
.Macintosh a#appStore {
    margin-bottom: 20px;
}

#swContent ul li a {
    line-height: 44px;
    color: #003865;
}

#swContent ul li a:hover {
    text-decoration: none;
}

</style>